module.exports = __webpack_public_path__ + "img/image131.8806cc3d.png";